import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { EmptyState, PageHeader } from '@/shared/ui';
import type { AdsFailure } from '../hooks/useAdsState';

interface Props {
  title: string;
  subtitle?: string;
  className?: string;
  failures: AdsFailure[];
}

/** A whole ads page shown instead of the Connect screen when the only ad platform is in status 'error'. */
export function AdsConnectionFailed({ title, subtitle, className, failures }: Props) {
  return (
    <div className={className}>
      <PageHeader title={title} subtitle={subtitle} />
      <div data-testid="ads-connection-failed">
        <EmptyState
          icon={<AlertTriangle size={28} aria-hidden />}
          title="Ad connection failed"
          description={failures.map((f) => `${f.platform}: ${f.reason} ${f.fix}`).join(' ')}
        />
      </div>
    </div>
  );
}
